import { useTranslation } from 'react-i18next';
import sortBy from 'lodash/sortBy';

import { SportType } from '__generated__/graphql';
import { useMemo } from 'react';
import GetSportTypesQuery from './GetSportTypesQuery';
import useQuery from '../../api/useQuery';

export const popularSportTypes = [
  SportType.running,
  SportType.trail_running,
  SportType.obstacle_run,
  SportType.cycling,
  SportType.gravel_cycling,
  SportType.mountainbiking,
  SportType.triathlon,
  SportType.walking,
  SportType.fitness,
];

const useGroupedSportTypes = () => {
  const { t } = useTranslation();

  const { data } = useQuery(GetSportTypesQuery, {
    fetchPolicy: 'cache-and-network',
  });

  return useMemo(() => {
    const nonPopularSportTypes = data?.sportTypes.filter(
      (sportType) => sportType !== SportType.other && !popularSportTypes.includes(sportType),
    ) ?? [];

    const otherSportTypes = [
      ...sortBy(nonPopularSportTypes, (sportType) => t(`common:sport_types.${sportType}`)),
      SportType.other,
    ];

    const allSportTypes = [
      ...sortBy([...popularSportTypes, ...nonPopularSportTypes], (sportType) => t(`common:sport_types.${sportType}`)),
      SportType.other,
    ];

    return {
      popularSportTypes,
      otherSportTypes,
      allSportTypes,
    };
  }, [t, data?.sportTypes]);
};

export default useGroupedSportTypes;
